import Dropdown from "@shared/v2/Dropdown";

const LimitBar = ({ limit, setLimit }) => {
  return (
    <div className="tw-h-48px tw-mt-4px tw-flex tw-flex-row tw-justify-between tw-items-start">
      <span className="tw-w-[292px] tw-text-10px">
        <strong>Not seeing as many properties as expected?</strong> Opportunities automatically filters out
        active listings to protect you.
      </span>
      <div className="tw-flex tw-flex-row tw-items-center">
        Show
        <Dropdown
          className="tw-mx-12px"
          options={options}
          onChange={(e) => setLimit(e.value)}
          value={options.find((o) => o.value === limit)}
          menuPlacement="top"
          menuShouldComeToFront
        />
        results per search
      </div>
    </div>
  );
};

export default LimitBar;

const options = [100, 500, 1000].map((n) => ({ label: n, value: n }));
